/**
 * Typ ID feature.
 */
enum FeatureIdType {
    /**
     * Standardní ID feature.
     * Vazba mezi Feature a ID je 1:1.
     */
    FEATURE_ID = 'FEATURE_ID',

    /**
     * ID seskupující množinu souvisejících features.
     * Vazba mezi Feature a ID je N:1.
     */
    GROUP_ID = 'GROUP_ID',

    /**
     * Jedno z vnořených ID pod danou feature.
     * Vazba mezi Feature a ID je 1:N.
     */
    NESTED_ID = 'NESTED_ID',
}

export default FeatureIdType;
